import React from "react";

export const ModalFooterControls = (props) => (
  <div
    className={`session-footer-controls ${
      props.hideCancel ? "" : "include-cancel-button"
    }`}
  >
    {props.innerComponent}
    {!props.hideCancel && (
      <button className="btn btn-cancel" onClick={props.toggleModal}>
        Cancel
      </button>
    )}
    <div className="bp3-dialog-footer-actions">
      {!props.hideBackButton && props.firstStep !== props.currentStep && (
        <button className="btn btn-info back-button" onClick={props.back}>
          Back
        </button>
      )}
      <button
        className="btn btn-primary"
        onClick={props.finalStep ? props.finalStepFn : props.next}
        disabled={props.loading || props.finalStepFnDisabled}
      >
        {props.loading ? (
          <i className="fa fa-spinner fa-spin" />
        ) : props.finalStep ? (
          props.finalStepLabel
        ) : (
          "Next"
        )}
      </button>
    </div>
  </div>
);

export const ModalHeaderControls = (props) => (
  <div className="bp3-dialog-header">
    {props.innerComponent}
    {!props.hideCancel && (
      <button
        className="bp3-dialog-close-button bp3-icon-small-cross im-ss-delete"
        onClick={props.toggleModal}
      />
    )}
    <div className="bp3-dialog-header-actions">
      {!props.hideBackButton && props.firstStep !== props.currentStep && props?.fromInvalid && (
        <a className="back-button" onClick={props.back} />
      )}
    </div>
  </div>
);
